// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IEligibleServicesSearchResponse,
  IPolicyEligibleServicesDto,
} from '../models/index';
import {
    IEligibleServicesSearchResponseFromJSON,
    IEligibleServicesSearchResponseToJSON,
    IPolicyEligibleServicesDtoFromJSON,
    IPolicyEligibleServicesDtoToJSON,
} from '../models/index';

export interface SearchEligibleServicesRequest {
    serviceOn: string;
    searchString: string;
    employeeId?: string;
    dependentId?: string;
    overrideRunout?: boolean;
}

export interface SearchServicesByPlanRequest {
    policyIds: Set<number>;
    searchString: string;
}

/**
 * AiSearchControllerApi - interface
 * 
 * @export
 * @interface AiSearchControllerApiInterface
 */
export interface AiSearchControllerApiInterface {
    /**
     * 
     * @param {string} serviceOn 
     * @param {string} searchString 
     * @param {string} [employeeId] 
     * @param {string} [dependentId] 
     * @param {boolean} [overrideRunout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiSearchControllerApiInterface
     */
    searchEligibleServicesRaw(requestParameters: SearchEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEligibleServicesSearchResponse>>;

    /**
     */
    searchEligibleServices(requestParameters: SearchEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEligibleServicesSearchResponse>;

    /**
     * 
     * @param {Set<number>} policyIds 
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiSearchControllerApiInterface
     */
    searchServicesByPlanRaw(requestParameters: SearchServicesByPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEligibleServicesDto>>>;

    /**
     */
    searchServicesByPlan(requestParameters: SearchServicesByPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEligibleServicesDto>>;

}

/**
 * 
 */
export class AiSearchControllerApi extends runtime.BaseAPI implements AiSearchControllerApiInterface {

    /**
     */
    async searchEligibleServicesRaw(requestParameters: SearchEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEligibleServicesSearchResponse>> {
        if (requestParameters['serviceOn'] == null) {
            throw new runtime.RequiredError(
                'serviceOn',
                'Required parameter "serviceOn" was null or undefined when calling searchEligibleServices().'
            );
        }

        if (requestParameters['searchString'] == null) {
            throw new runtime.RequiredError(
                'searchString',
                'Required parameter "searchString" was null or undefined when calling searchEligibleServices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        if (requestParameters['serviceOn'] != null) {
            queryParameters['service_on'] = requestParameters['serviceOn'];
        }

        if (requestParameters['searchString'] != null) {
            queryParameters['search_string'] = requestParameters['searchString'];
        }

        if (requestParameters['overrideRunout'] != null) {
            queryParameters['override_runout'] = requestParameters['overrideRunout'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ai/search/services/eligible`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEligibleServicesSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchEligibleServices(requestParameters: SearchEligibleServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEligibleServicesSearchResponse> {
        const response = await this.searchEligibleServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchServicesByPlanRaw(requestParameters: SearchServicesByPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPolicyEligibleServicesDto>>> {
        if (requestParameters['policyIds'] == null) {
            throw new runtime.RequiredError(
                'policyIds',
                'Required parameter "policyIds" was null or undefined when calling searchServicesByPlan().'
            );
        }

        if (requestParameters['searchString'] == null) {
            throw new runtime.RequiredError(
                'searchString',
                'Required parameter "searchString" was null or undefined when calling searchServicesByPlan().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['policyIds'] != null) {
            queryParameters['policy_ids'] = requestParameters['policyIds'];
        }

        if (requestParameters['searchString'] != null) {
            queryParameters['search_string'] = requestParameters['searchString'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ai/search/services/by-plan`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPolicyEligibleServicesDtoFromJSON));
    }

    /**
     */
    async searchServicesByPlan(requestParameters: SearchServicesByPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPolicyEligibleServicesDto>> {
        const response = await this.searchServicesByPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
